import { Flex, Text } from '@chakra-ui/react';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface RequestConfirmationModalProps {
  onSubmit: () => void;
  onClose: () => void;
}

export const RequestSubmissionUpdatesConfirmationModal = ({
  onClose,
  onSubmit
}: RequestConfirmationModalProps) => {
  return (
    <Modal isOpen onClose={onClose} width="448px" data-cy="confirmation-modal">
      <Flex padding={8} gap={6} flexDirection="column">
        <Flex alignItems="flex-start" flexDirection="column">
          <FontAwesomeIcon fontSize={32} icon={faEnvelope} />
        </Flex>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Request Submission Updates?</Text>
          <Text>
            The authors will receive an email notification to update the
            requested fields.
          </Text>
        </Flex>

        <Flex gap={2} justifyContent="flex-end">
          <Button
            onClick={onClose}
            variant="secondary"
            data-cy="request-submission-modal-cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            onClick={onSubmit}
            data-cy="request-submission-modal-submit-button"
          >
            Request Updates
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
